import { Router } from "@angular/router";
import { GlobalServiceService } from "src/app/services/global-service.service";
import { ApiBasic } from "./services/api-basic";
import { LocalstorageService } from "./services/localstorage.service";
import { LoginService } from "./login.service";
import { Component, HostListener } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil, map } from "rxjs/operators";
import { versionFirebaseService } from "./firebase-service/firebase-service";
import Swal from "sweetalert2";
import { NotificacionesService } from "./components/notificaciones.service";
import { MatDialog } from "@angular/material";
import { Platform } from "@angular/cdk/platform";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  currentVersion = "0.9.1";
  versionfirebase;
  interval;
  alertStatus;
  alertString;
  public isLogged: boolean;
  public goBack: boolean;
  private _unsubscribeAll: Subject<any>;
  profile: any = this.app.getUserInfo();

  flagLogs: boolean = true;

  userActivity1;
  userInactive1: Subject<any> = new Subject();
  statusAlert: boolean = false;
  userStatus: boolean = false;
  constructor(
    public app: GlobalServiceService,
    public versionFirebaseService: versionFirebaseService,
    public _firebase: NotificacionesService,
    public _login: LoginService,
    private _localstorage: LocalstorageService,
    public apiBasic: ApiBasic,
    public _global: GlobalServiceService,
    private router: Router,
    private dialog: MatDialog,
    public platform: Platform
  ) {
    console.log(`Version compilada 0.9.1 - Version firebase 0.9.1 Cambios 27 oct 2023 v1`);

    this.alertVersionMaintenance();
  }

  setTimeout() {
    if (localStorage.getItem("userInfo")) {
      this.statusAlert = false;
      this.userActivity1 = setTimeout(() => {
        this.statusAlert = true;
        const audio = new Audio("assets/notificacion.mp3");
        audio.play();
        Swal({
          title: "Tu sesión está por terminar por inactividad",
          // text: "Seleccione cancelar si quiere anular el proceso",
          type: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "OK",
          // cancelButtonText : 'Cancelar'
        }).then((result) => {
          if (result.value == true) {
            this.statusAlert = false;
            Swal({
              title: "Acción cancelada",
              text: "",
              type: "info",
            });
          } else {
          }
        });

        setTimeout(() => {
          if (this.statusAlert) {
            this.userInactive1.next(1);
          }
        }, 20000);
      }, 1800000);
    }
  }

  ngOnInit() {
    const userVerify = this.profile ? true : false;
    this._global.flagLogs().subscribe((res: any) => {
      res.map(async (element) => {
        if (element.flagLogs) {
          this.flagLogs = element.flagLogs;
          this._global.flagLogsData = true;
        }
      });
    });

    if (userVerify) {
      if (localStorage.getItem("userInfoEncrypted")) {
        this._login.checkToken().subscribe(
          (res: any) => {
            this._global.token = res.access;
            this._localstorage.sendToken("s");
            this._localstorage.sendToken("Message from token!");
            this.userStatus = true;

            //No requiere usuario
            this.loadBase2();
            this._unsubscribeAll = new Subject();
            this.loadVersion();
            this.setTimeout();
            this.userInactive1.subscribe(() => {
              if (localStorage.getItem("userInfo")) {
                Swal.close();
                localStorage.removeItem("userInfo");
                localStorage.removeItem("access");
                localStorage.removeItem("userInfoEncrypted");
                Swal.close();
                this.app.setLogged(false);
                Swal.close();
                this.router.navigate(["login"]);
                Swal.close();
              }
            });
            this.loadBase2();

            //requiere usuario
            let userId;
            userId = this.profile ? this.profile.usuario_id.toString() : null;

            if (userId) {
              const dataInfo = {
                os: this._global.detectBrowserName(),
                tipo_dispositivo: "web",
                usuario_id: userId,
              };
              this._global.tracking(dataInfo).subscribe(
                (res) => {
                  // console.log(res);
                },
                (err) => {
                  // console.error(err);
                }
              );
              this.cargaMasiva(userId);
              // this._firebase.getUser(userId).subscribe((data: any) => {
              //   if (data) {
              //     if (data.messageText !== undefined) {
              //       if (data.messageText !== "") {
              //         if (
              //           data.messageText ==
              //           "Se ha completado la actualizacion de carga masiva de ordenes"
              //         ) {
              //           this._firebase.setUserOnBulkLoadFalse(
              //             this.profile.usuario_id.toString()
              //           );
              //         }
              //         Swal({
              //           title: "Carga Masiva",
              //           text: data.messageText,
              //           // type: 'error'
              //         });
              //         this._firebase.resetMessage(userId);
              //       }
              //     }
              //   }
              // });
            }

            /*const OneSignal = window['OneSignal'] || [];
            OneSignal.push(function() {
              OneSignal.init({
                appId: 'cb0f0a92-e4d3-44ac-af3f-1c0cc1ba7daf',
                autoRegister: true,
                notifyButton: {
                  enable: false,
                },
              });
            });
            console.log('OneSignal Initialized');
            OneSignal.push(function () {
              console.log('Register For Push');
              OneSignal.push(["registerForPushNotifications"])
            });
            OneSignal.push(function () {
              // Occurs when the user's subscription changes to a new value.
              OneSignal.on('subscriptionChange', function (isSubscribed) {
                console.log("The user's subscription state is now:", isSubscribed);
                OneSignal.getUserId().then(function (userId) {
                  console.log("User ID is", userId);
                });
              });
            });*/

            //no requiere usuario
            if (localStorage.getItem("remember") == "true") {
            } else {
              localStorage.removeItem("userInfo");
              localStorage.removeItem("access");
              localStorage.removeItem("userInfoEncrypted");
              this.app.setLogged(false);
              this.router.navigate(["login"]);
              clearInterval(this.interval);
              this.dialog.closeAll();
              localStorage.clear();
              Swal.close();
            }

            //Requiere usuario
            this.app.setLogged(true);
            this.app.logged
              .pipe(takeUntil(this._unsubscribeAll))
              .subscribe((value) => {
                this.isLogged = true;
                if (this.isLogged) {
                  if (this.interval != undefined) {
                    clearInterval(this.interval);
                  }
                  this.interval = setInterval(this.check.bind(this), 60000);
                }
              });
          },
          (err) => {
            localStorage.removeItem("userInfo");
            localStorage.removeItem("access");
            localStorage.removeItem("userInfoEncrypted");
            this.app.setLogged(false);
            this.router.navigate(["login"]);
            if (this._global.flagLogsData) {
              console.warn("err");
            }
          }
        ),err=>{
          console.log(err);
          Swal.close();
          localStorage.removeItem("userInfo");
          localStorage.removeItem("access");
          localStorage.removeItem("userInfoEncrypted");
          this.app.setLogged(false);
          this.router.navigate(["login"]);
        }}
    } else {
      //No requiere usuario
      this.loadBase2();
      this._unsubscribeAll = new Subject();
      this.loadVersion();
      this.setTimeout();
      this.userInactive1.subscribe(() => {
        if (localStorage.getItem("userInfo")) {
          localStorage.removeItem("userInfo");
          localStorage.removeItem("access");
          localStorage.removeItem("userInfoEncrypted");
          Swal.close();
          this.app.setLogged(false);
          Swal.close();
          this.router.navigate(["login"]);
          Swal.close();
        }
      });
      this.loadBase2();
      //no requiere usuario
      if (localStorage.getItem("remember") == "true") {
      } else {
        localStorage.clear();
      }

      this.userStatus = true;
    }
  }

  @HostListener("window:mousemove") refreshUserState() {
    clearTimeout(this.userActivity1);
    this.setTimeout();
  }
  cargaMasiva(id) {
    this._firebase.getUser(id.toString()).subscribe((data: any) => {
      if (data) {
        if (data.messageText !== undefined) {
          if (data.messageText !== "") {
            if (
              data.messageText ==
              "Se ha completado la actualizacion de carga masiva de ordenes"
            ) {
              this._firebase.setUserOnBulkLoadFalse(id.toString());
            }
            Swal({
              title: "Carga Masiva",
              text: data.messageText,
              // type: 'error'
            });
            this._firebase.resetMessage(id.toString());
          }
        }
      }
    });
  }
  check() {
    if (localStorage.getItem("userInfoEncrypted")) {
      this._login.checkToken().subscribe(
        (res: any) => {
          this._global.token = res.access;
          this._localstorage.sendToken("s");
          // localStorage.setItem('access', res.access);
          this._localstorage.sendToken("Message from token!");
          // console.log('Cron de login check');
        },
        (err) => {
          console.log(err);

          if (this._global.flagLogsData) {
            console.warn("err");
          }
        }
      );
    }
  }

  sendMessageUpdate(): void {
    this._localstorage.sendMessage(
      "Message from Home Component to App Component!"
    );
  }

  loadVersion() {
    this.versionFirebaseService
      .getFirebaseVersion()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((data: any) => {
        this.versionfirebase = data.version;
        console.log(
          `Version compilada ${this.currentVersion} - Version firebase ${this.versionfirebase} Cambios 27 oct 2023 v1`
        );

        if (this.versionfirebase != this.currentVersion) {
          this.alertVersion();
          this.interval = setInterval(
            this.alertVersion.bind(this),
            80000 // <- 1 minute
          );
        }
      });
  }
  //
  loadBase2() {
    this.versionFirebaseService.getTypeBase().subscribe((data: any) => {
      // localStorage.setItem("base_url", data.base_url);
      // localStorage.setItem("base_image_url", data.base_image_url);
      // localStorage.setItem("base_cargas_masivas", data.base_cargas_masivas);

      // localStorage.setItem("base_url", 'https://manteapi.kof.com.mx:8080');
      // localStorage.setItem("base_image_url", 'https://storagelaplataformafemsa.s3.amazonaws.com/');
      // localStorage.setItem("base_cargas_masivas",'https://manteapi.kof.com.mx:8080');
      // this._global.base_url = data.base_url;
      // this._global.base_image_url = data.base_image_url;
      // this._global.base_cargas_masivas = data.base_cargas_masivas;
      this.sendMessageUpdate();

      if (localStorage.getItem("userInfoEncrypted")) {
        this._login.checkToken().subscribe(
          (res: any) => {
            this._global.token = res.access;
            this._localstorage.sendToken("s");
          },
          (err) => {
            if (this._global.flagLogsData) {
              console.warn("err");
            }
          }
        );
      }
    });
  }

  alertVersion() {
    if (this.versionfirebase != this.currentVersion) {
      Swal({
        title:
          "Existe una nueva version web, favor de borrar cache CTRL+SHIFT+R",
      });
    }
  }

  alertVersionMaintenance() {
    this.versionFirebaseService.getFirebaseAlert().subscribe((data: any) => {
      this.alertStatus = data.alert.status;
      this.alertString = data.alert.alert;
      if (this.alertStatus === 1) {
        this.alertVersionStatus();
        this.interval = setInterval(
          this.alertVersionStatus.bind(this),
          60000 // <- 1 minute
        );
      }
    });
  }

  alertVersionStatus() {
    if (this.alertStatus === 1) {
      Swal({
        title: this.alertString,
        allowOutsideClick: false,
        // timer: 3000,
      });
    }
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  getAlert() {}
}
